/* eslint-disable react/prop-types */
import React from 'react';
import { PieChart, Pie } from 'recharts';

class Chart01 extends React.Component {
  render() {
    return (
      <PieChart width={120} height={120}>
        <Pie data={this.props.data} dataKey="value" cx="50%" cy="50%" outerRadius={60} startAngle={-270} />
      </PieChart>
    );
  }
}

export default Chart01;
